export const mapShop = (shop?: string): string => {
  return (
    {
      'engbers-xxl': 'XXL',
      'engbers-germany': 'ENGBERS GERMANY',
      'emilio-adani': 'emilio adani',
    }[shop ?? ''] || 'engbers'
  );
};
